export default __webpack_public_path__ + "static/media/bio1.6ecfd837.png";